import { Warning } from "@phosphor-icons/react";

import { cn } from "@/lib/utils";

/**
 * Small amber flag marking a still-empty field that something is waiting on.
 * The `variant` sets the wording by which readiness the field belongs to:
 * `preship` (pre-configuration, set before shipping) → "Required";
 * `handoff` (the setupData payload handed off at the end) → "Needed for handoff".
 */
type MissingVariant = "preship" | "handoff";

const VARIANT_LABEL: Record<MissingVariant, string> = {
  preship: "Required",
  handoff: "Needed for handoff",
};

export function MissingChip({
  variant = "handoff",
  label,
  className,
}: {
  variant?: MissingVariant;
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "bg-warning/10 text-warning inline-flex shrink-0 items-center gap-1 rounded-sm px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap",
        className,
      )}
    >
      <Warning weight="light" className="size-3" />
      {label ?? VARIANT_LABEL[variant]}
    </span>
  );
}
